var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVlanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 0C5.512 0 4.8 0.712 4.8 1.6V4C4.8 4.888 5.512 5.6 6.4 5.6H7.2V7.2H0V8.8H3.2V10.4H2.4C1.512 10.4 0.8 11.112 0.8 12V14.4C0.8 15.288 1.512 16 2.4 16H5.6C6.488 16 7.2 15.288 7.2 14.4V12C7.2 11.112 6.488 10.4 5.6 10.4H4.8V8.8H11.2V10.4H10.4C9.512 10.4 8.8 11.112 8.8 12V14.4C8.8 15.288 9.512 16 10.4 16H13.6C14.488 16 15.2 15.288 15.2 14.4V12C15.2 11.112 14.488 10.4 13.6 10.4H12.8V8.8H16V7.2H8.8V5.6H9.6C10.488 5.6 11.2 4.888 11.2 4V1.6C11.2 0.712 10.488 0 9.6 0H6.4ZM6.4 1.6H9.6V4H6.4V1.6ZM2.4 12H5.6V14.4H2.4V12ZM10.4 12H13.6V14.4H10.4V12Z",
    fill: "#39A772"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlanIcon);
export default __webpack_public_path__ + "static/media/vlanIcon.0fe011b1dc065b1f55d2d07abdeb87be.svg";
export { ForwardRef as ReactComponent };